import React from 'react';
import { Box, GuideDot } from 'edenred-ui';
import { useOnboardingWizard } from '@epi-shared/hooks';
import { useTranslation } from 'react-i18next';

export const GuidingDots = () => {
  const { t } = useTranslation();
  const { isOnBoardingActive } = useOnboardingWizard();

  return (
    <>
      {!isOnBoardingActive && (
        <>
          <Box position="absolute" top={-85} left={215}>
            <GuideDot
              storageKey="manage-employees-guide-dot"
              tooltipDescription={t('guided_tour.manage_employees')}
              autoHide
            />
          </Box>
          <Box position="absolute" top={125} left={820} zIndex={1}>
            <GuideDot
              storageKey="beneficiaries-list-guide-dot"
              tooltipDescription={t('guided_tour.beneficiaries_list')}
              autoHide
            />
          </Box>
        </>
      )}
    </>
  );
};
